import { render, staticRenderFns } from "./EditFormHidden.vue?vue&type=template&id=be2f9b88"
import script from "./EditFormHidden.vue?vue&type=script&lang=js"
export * from "./EditFormHidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports